export default __webpack_public_path__ + "static/media/manejoEmociones-min.e01f78d1.jpg";